const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Material Invoice Before Truckout',
  description: 'This config makes the truckout enable only after material invoice is available',
  sortOrder: 1,
  name: 'material_invoice_before_truckout',
  documentKey: 'material_invoice_before_truckout',
  values: {
    material_invoice_before_truckout: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Material Invoice Before Truckout',
      documentKey: 'material_invoice_before_truckout',
    },
  },
};
